<template>
   <div>
      <hold-switch-header :completion-date="completionDate" :switch-id="customerId" :is-hold-switch="isHoldSwitch"></hold-switch-header>
   </div>
</template>

<script>
import HoldSwitchHeader from '../components/hold-switch-header/HoldSwitchHeader.vue';
import { mapState } from 'vuex';

export default {
  name: 'SwitchHold',
  async mounted () {
    if (!this.isHoldSwitch) {
      this.$router.push({ name: 'currentTariff' });
    }

    this.$store.dispatch('page_loader/start', 0);
    await this.$store.dispatch('token/getToken');
    this.$store.dispatch('page_loader/stop');

    this.$store.dispatch('tracing/addAction', { name: 'Page', value: 'Switch Hold' });
    this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Viewed' });
    await this.$store.dispatch('tracing/saveActions');
  },
  computed: {
    ...mapState({
      customerId: ({ storage }) => storage.quote.switchId,
      isHoldSwitch: ({ storage }) => storage.isHoldSwitch,
      completionDate: ({ session }) => session.quoteParams.completionDate
    })
  },
  components: {
    HoldSwitchHeader
  }
};
</script>

<style lang="scss" scoped>
.footprint {
  position: relative;
  padding: 0px 15px 0px 30px !important;

  img {
    position: absolute;
    max-width: 22px;
    top: -6px;
    left: 0;
  }
}
</style>
